import React from 'react';
import RouterSideNav from '../SideNav';

const Sidebar = () => {
    return ( <>
<RouterSideNav></RouterSideNav>    </> );
}
 
export default Sidebar;